var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("app-ubl-send-modal", {
    attrs: { link: _vm.publicLink },
    on: {
      sent: function ($event) {
        return _vm.markSent($event)
      },
      download: function ($event) {
        return _vm.download()
      },
      close: function ($event) {
        return _vm.close()
      },
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }